import React from 'react';
import { Heading } from '@chakra-ui/react'
import ATMTransactionInquiryFormHandler from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/atmTransactionInquiry/ATMTransactionInquiryFormHandler'

const AtmTransactionInquiryPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>ATM Transaction Inquiry</Heading>
      <ATMTransactionInquiryFormHandler />
    </>
  )
}

export default AtmTransactionInquiryPage